<template>
    <div
        v-if="contentStore.contentData?.blocksFrontendAlert?.length && contentStore.contentData?.blocksFrontendAlert?.[0].text!==null"
        class="m-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-8">
        <div class="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
            <BaseCard
                :header="false"
                class=" w-full p-2 max-w-full border border-gray-300">
                <strong>Hinweis von {{ contentStore.contentData?.title }}:</strong>
                <div
                    v-for="(element,key) in contentStore.contentData?.blocksFrontendAlert"
                    :key="key"
                    class="pt-2 cms-text">
                    <div v-html="element?.text" />
                </div>
            </BaseCard>
        </div>
    </div>
</template>

<script setup>
import {useContentStore} from "@/store/content"

const contentStore = useContentStore()
</script>